import http from '@/utils/request.js'
/**
 * 获取任务列表
 * @param {*} page
 * @param {*} limit
 * @param {*} workDescribe
 * @param {*} systemUserId
 */
export const taskList = (page, limit, workDescribe, systemUserId, active) => {
  return http({
    method: 'post',
    url: '/api/Task/index',
    data: {
      page,
      limit,
      workDescribe,
      systemUserId,
      active
    }

  })
}
/**
 * 获取任务详情
 * @param {*} workId
 */
export const taskDetails = (workId) => {
  return http({
    method: 'post',
    url: '/api/Task/details',
    data: {
      workId
    }
  })
}
/**
 * 更新任务图片
 * @param {*} fileParams
 * @param {*} workId
 */
export const updateWorkImage = (fileParams, workId) => {
  return http({
    method: 'post',
    url: '/api/Task/updateWorkImage',
    data: {
      fileParams,
      workId
    }
  })
}
